export const categories = [
  {
    slug: 'xianxiang-jiexi',
    name: '现象解析',
    description: '解读人妻猎人现象的起源、演变与当代都市文化语境',
    icon: 'ri-search-eye-line',
    image: 'https://readdy.ai/api/search-image?query=abstract%20urban%20landscape%20with%20warm%20amber%20lighting%20and%20soft%20shadows%2C%20minimalist%20composition%2C%20contemporary%20art%20style%2C%20emotional%20atmosphere%2C%20warm%20beige%20and%20terracotta%20tones%2C%20clean%20background&width=800&height=500&seq=cat-phenomenon&orientation=landscape',
  },
  {
    slug: 'xinli-fenxi',
    name: '心理分析',
    description: '从心理学视角剖析猎艳者与被猎者的深层心理动机',
    icon: 'ri-mental-health-line',
    image: 'https://readdy.ai/api/search-image?query=abstract%20minimalist%20composition%20of%20two%20intersecting%20shapes%20representing%20human%20connection%2C%20warm%20coral%20and%20beige%20tones%2C%20soft%20gradient%20background%2C%20contemporary%20art%20style%2C%20emotional%20depth&width=800&height=500&seq=cat-psychology&orientation=landscape',
  },
  {
    slug: 'shehui-yingxiang',
    name: '社会影响',
    description: '探讨这一现象对家庭结构、婚姻制度与社会伦理的冲击',
    icon: 'ri-global-line',
    image: 'https://readdy.ai/api/search-image?query=abstract%20urban%20society%20concept%20with%20overlapping%20warm%20geometric%20shapes%2C%20amber%20and%20terracotta%20color%20palette%2C%20minimalist%20design%2C%20soft%20atmospheric%20lighting%2C%20clean%20contemporary%20aesthetic&width=800&height=500&seq=cat-society&orientation=landscape',
  },
  {
    slug: 'hunyin-baohu',
    name: '婚姻保护',
    description: '提供实用的婚姻危机预防策略与情感关系维护指南',
    icon: 'ri-shield-check-line',
    image: 'https://readdy.ai/api/search-image?query=abstract%20protective%20shield%20concept%20with%20warm%20golden%20and%20beige%20tones%2C%20minimalist%20geometric%20design%2C%20soft%20glowing%20light%2C%20contemporary%20art%20style%2C%20serene%20atmosphere&width=800&height=500&seq=cat-marriage&orientation=landscape',
  },
  {
    slug: 'qinggan-lunli',
    name: '情感伦理',
    description: '深入讨论婚外情中的道德困境、伦理边界与人性反思',
    icon: 'ri-scales-line',
    image: 'https://readdy.ai/api/search-image?query=abstract%20balance%20and%20ethics%20concept%20with%20warm%20terracotta%20and%20beige%20tones%2C%20minimalist%20geometric%20composition%2C%20soft%20atmospheric%20lighting%2C%20contemporary%20art%20style%2C%20serene%20mood&width=800&height=500&seq=cat-ethics&orientation=landscape',
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});